<!-- stickyHeader -->
{#await promise}
  <DataTableSkeleton 
    showToolbar={false} 
    headers={['PMID', 'Source', 'Title', 'Author', 'Journal', 'Year']} rows={10} 
  />
{:then data}
  {#if (data.length == 0)}
    <h5>No citations for this worksapce</h5>
    <br/>
    <div class="flex-wrap">
      <Button icon={ImportIcon} disabled={loadingCitations} on:click={e=>open=true}>Import citations</Button>
      {#if loadingCitations}
        <Loading withOverlay={false} small />
      {/if}
    </div>

    <Modal
      size="xs"
      preventCloseOnClickOutside
      bind:open
      modalHeading="Import citations to workspace?"
      primaryButtonText="Confirm"
      secondaryButtonText="Cancel"
      on:click:button--secondary={() => (open = false)}
      on:submit={() => modalAction()}
    >
      <div>This may take a few minutes.</div>
    </Modal>

  {:else}
    
    <DataTable
      zebra
      sortable
      title="{data.length} Imported citations"  
      description=""
      headers={[
        { key: 'pmid', value: 'PMID'},
        { key: 'source', value: 'Source'},
        { key: 'title', value: 'Title'},
        { key: 'author', value: 'Author' }, 
        { key: 'journal', value: 'Journal' }, 
        { key: 'year', value: 'Year' }, 
      ]}
      rows={data}
    >
    </DataTable>

  {/if}
{/await}

<style>
.flex-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>

<script>
  export let id

	// Firebase libraries
  import { Firestore, Functions } from '../../../config/firebase'

	// Native Carbon Components
  import { DataTable, DataTableSkeleton } from "carbon-components-svelte" 
  import {
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    ToolbarMenu,
    ToolbarMenuItem,
    Button,
    Modal,
    Loading,
  } from "carbon-components-svelte"
  import {
    OverflowMenu,
    OverflowMenuItem,
    Link,
  } from "carbon-components-svelte"
  import Add16 from "carbon-icons-svelte/lib/Add16"
  import Launch16 from "carbon-icons-svelte/lib/Launch16"
  import Launch32 from "carbon-icons-svelte/lib/Launch32"
  import ImportIcon from "carbon-icons-svelte/lib/DocumentImport32"

  const NO_DATA = 'NO DATA TO DISPLAY'

  // const user = get(auth)

  let open = false
  let loadingCitations = false

  $: promise = getWorksapceCitations(id)

	async function getWorksapceCitations(id) {
		try { 
      // console.log(id)
      let items = []
      let snap = await Firestore.collection('snps').doc(id).collection('citations').get()
      // console.log("got snap",snap.size)
			if (snap.size > 0) {
        snap.forEach( doc => {
          let data = doc.data()
          data.id = doc.id
          items.push(data)
        })
        // console.log("items",snap.size)
        return items
			} else { return items }
		} catch (error) {
      throw Error(error)  
    }
  }

  const modalAction = async () => {
    
    loadingCitations = true
    open = false 
    
    const loadCitations = Functions.httpsCallable('loadWorkspaceCitations')
    
		loadCitations({ id })
			.then( async (res) => {
				if (!res.data.error) {
          console.log("citations loaded",res.data.count)
          await Firestore.collection('snps').doc(id).update( {ws_citations: res.data.count} )
          // window.history.go(0)
          promise = getWorksapceCitations(id)
				} else {
					throw Error(res.data.error)
				}		
			})
			.catch((error) => {
        loadingCitations = false
				console.log("citations ERROR",error)
			})
  }
</script>